// components/Celebration/CTAButtons.jsx
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const CTAButtons = ({ onNext, onBack, hideBack }) => {
  return (
    <div className="flex items-center gap-4">
      {!hideBack && (
        <button
          onClick={onBack}
          className="flex items-center justify-between font-gotham font-medium gap-2 lg:gap-6  px-4 py-2 lg:py-3 rounded-full border border-gray-300 
                     hover:bg-gray-100 transition text-gray-700"
        >
        <span className="bg-white text-black rounded-full p-0.5">
          <ChevronLeft size={18} />
        </span>
          Back
        </button>
      )}

      <button
        onClick={onNext}
        className="flex items-center justify-between gap-2 lg:gap-6 px-5 py-2 lg:py-3 rounded-full font-gotham font-medium
                   bg-black text-white hover:bg-gray-800 transition"
      >
        Continue
        <span className="bg-white text-black rounded-full p-0.5">
        <ChevronRight size={18} />
        </span>
      </button>
    </div>
  );
};

export default CTAButtons;
